var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 36C52 18 32 4 32 4C32 4 12 18 12 36C12 41.3043 14.1071 46.3914 17.8579 50.1421C21.6086 53.8929 26.6957 56 32 56C37.3043 56 42.3914 53.8929 46.1421 50.1421C49.8929 46.3914 52 41.3043 52 36Z",
    stroke: "url(#paint0_linear_1855_33831)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0254 47.8004C36.4698 47.386 38.7254 46.2231 40.4808 44.4722C42.2361 42.7213 43.4048 40.4688 43.8254 38.0254",
    stroke: "url(#paint1_linear_1855_33831)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_33831",
    x1: 16.2535,
    y1: 42.5184,
    x2: 45.3643,
    y2: 33.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_33831",
    x1: 35.0675,
    y1: 45.2661,
    x2: 41.7661,
    y2: 42.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLiquidity);
export default __webpack_public_path__ + "static/media/home-liquidity.e8b1b528b0c4195e1a91b31f5ded2a74.svg";
export { ForwardRef as ReactComponent };